import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const { getProfileBegin, getProfileSuccess, getProfileErr } = actions;

const getProfileAPIName ='profile';
const getProfileAPINameV1 ='admin/v1/profile';
const updateHostProfile ='admin/v1/update-host-profile';

const getProfile = () => {
  return async (dispatch) => {
    dispatch(getProfileBegin());
    try {
      const response = await DataService.get(getProfileAPIName);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(getProfileErr(response?.data?.message));
        return response.data;
      } else {
        dispatch(getProfileSuccess(response?.data));
        return response.data;
      }
    } catch (err) {
      dispatch(getProfileErr(err));
    }
  };
};

const getProfileV1 = (values = "") => {
  return async (dispatch) => {
    dispatch(getProfileBegin());
    try {
      const response = await DataService.get(getProfileAPINameV1 + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(getProfileErr(response?.data?.message));
        return response.data;
      } else {
        dispatch(getProfileSuccess(response?.data));
        return response.data;
      }
    } catch (err) {
      dispatch(getProfileErr(err));
    }
  };
};

const updateHostProfileV1 = (values, callback) => {
  return async (dispatch) => {
    dispatch(getProfileBegin());
    try {
      const response = await DataService.post(updateHostProfile, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(getProfileErr(response?.data?.message));
      } else {
        dispatch(getProfileSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(getProfileErr(err));
    }
  };
};

export { getProfile, getProfileV1, updateHostProfileV1 };
